module.exports = __webpack_public_path__ + "img/img_flag_np.d75da330.png";